<template>
  <div class="nselectbox">
    <a-row type='flex' style="margin-bottom:20px;">
      <a-col :span='3'>
        <label>姓名：</label>
        <span>{{debInfo.realname}}</span>
      </a-col>
      <a-col :span='4'>
        <label>证件号码：</label>
        <span style="white-space:normap;">{{debInfo.chinaid}}</span>
      </a-col>
      <a-col :span='2'>
        <label>性别：</label>
        <span>{{debInfo.sex | tosex}}</span>
      </a-col>
      <a-col :span='4'>
        <label>联系方式：</label>
        <span>{{debInfo.phone}}</span>
      </a-col>
      <a-col :span='3'>
        <label>业务类型：</label>
        <span>{{debInfo.car_type_id | tocarName(APIKEY.carlist)}}</span>
      </a-col>
      <a-col :span="4">
        <label>原被告身份是否准确：</label>
        <span>{{debInfo.is_role_exact==3?'混合':(debInfo.is_role_exact==1?'是':'否')}}</span>
      </a-col>
      <a-col :span="4">
        <label>是否诉讼完毕：</label>
        <span>{{debInfo.cause_is_complete==0?'否':'是'}}</span>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span='9' style="display:flex;">
        <label>户籍所在地：</label>
        <div style="width:70%;">
          <Normap :tit='debInfo.province?(debInfo.province+debInfo.city+debInfo.area+debInfo.addr):null'></Normap>
        </div>
      </a-col>
      <a-col :span='7' style="display:flex;">
        <label>经常居住地：</label>
        <div style="width:70%;">
          <Normap :tit='debInfo.dwell_province?(debInfo.dwell_province+debInfo.dwell_city+debInfo.dwell_area+debInfo.dwell_addr):null'></Normap>
        </div>
      </a-col>
      <a-col :span='4'>
        <label>是否代偿完毕：</label>
        <span>{{debInfo.is_full_pay==1?'不详':(debInfo.is_full_pay==2?'是':'否')}}</span>
      </a-col>
      <a-col :span=' 4'>
        <label>最后代偿时间：</label>
        <span>{{debInfo.last_compensation_time | yearFormat}}</span>
      </a-col>
    </a-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default{
    name:'Basic',
    computed: {
    ...mapGetters([
        'debInfo',
        'APIKEY',       
      ])
    },
  }
</script>